module.exports = __webpack_public_path__ + "img/visa.1bbb3515.png";